import React, { useEffect, useState } from 'react';
import { adminUserAPI } from '../api';
import { fmtDate } from '../utils/date';

export default function Users() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => adminUserAPI.list().then(r => setUsers(r.data.users || [])).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const toggle = async (u) => {
    if (u.deactivated_at) { await adminUserAPI.reactivate(u.id); }
    else { if (!window.confirm(`Deactivate ${u.name}?`)) return; await adminUserAPI.deactivate(u.id); }
    load();
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div>
      <h1>Users ({users.length})</h1>
      <table>
        <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Business</th><th>Joined</th><th>Status</th><th></th></tr></thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.name}</td>
              <td style={{ color: '#94a3b8' }}>{u.email}</td>
              <td>{u.role}</td>
              <td>{u.business_name || '—'}<br /><span style={{ color: '#64748b', fontSize: '0.75rem' }}>{u.currency}</span></td>
              <td>{fmtDate(u.created_at)}</td>
              <td>{u.deactivated_at ? <span style={{ color: '#ef4444' }}>Inactive</span> : <span style={{ color: '#22c55e' }}>Active</span>}</td>
              <td>
                <button
                  className={u.deactivated_at ? 'btn-primary' : 'btn-danger'}
                  style={{ padding: '0.3rem 0.6rem', fontSize: '0.75rem' }}
                  onClick={() => toggle(u)}
                >
                  {u.deactivated_at ? 'Reactivate' : 'Deactivate'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
